import { render, staticRenderFns } from "./send-verification.vue?vue&type=template&id=8a8ceac0&scoped=true&"
import script from "./send-verification.vue?vue&type=script&lang=js&"
export * from "./send-verification.vue?vue&type=script&lang=js&"
import style0 from "./send-verification.vue?vue&type=style&index=0&id=8a8ceac0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8ceac0",
  null
  
)

export default component.exports